/**
 * Servicio para registrar errores en el backend
 */
class ErrorLogService {
  constructor() {
    this.apiUrl = process.env.REACT_APP_API_URL || "";
  }

  /**
   * Obtiene el token de autenticación
   */
  getAuthToken() {
    return localStorage.getItem("token");
  }

  /**
   * Registra un error en el backend
   * @param {Error} error - Objeto de error
   * @param {Object} additionalInfo - Información adicional
   * @returns {Promise<boolean>} - true si se registró correctamente
   */
  async logError(error, additionalInfo = {}) {
    try {
      const token = this.getAuthToken();
      
      // No registrar si no hay token (usuario no autenticado)
      if (!token) {
        console.warn("No auth token, skipping error logging");
        return false;
      }

      const errorData = {
        errorMessage: error.message || "Unknown error",
        stackTrace: error.stack || "",
        errorType: error.name || "Error",
        errorSource: "frontend",
        httpMethod: additionalInfo.httpMethod || null,
        requestUrl: additionalInfo.requestUrl || window.location.href,
        httpStatusCode: additionalInfo.httpStatusCode || null,
        userAgent: navigator.userAgent,
        ipAddress: null, // Se obtiene automáticamente en el backend
        additionalInfo: JSON.stringify({
          url: window.location.href,
          timestamp: new Date().toISOString(),
          component: additionalInfo.component || "Unknown",
          ...additionalInfo,
        }),
      };

      const response = await fetch(`${this.apiUrl}/api/private/error-log`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(errorData),
      });

      if (!response.ok) {
        console.error("Failed to log error to server:", response.status);
        return false;
      }

      return true;
    } catch (logError) {
      // Evitar bucle infinito - no registrar errores del logging
      console.error("Error logging failed:", logError);
      return false;
    }
  }

  /**
   * Registra un error de API
   * @param {Error} error - Error
   * @param {string} method - Método HTTP
   * @param {string} url - URL de la petición
   * @param {number} statusCode - Código de estado HTTP
   */
  async logApiError(error, method, url, statusCode) {
    return this.logError(error, {
      httpMethod: method,
      requestUrl: url,
      httpStatusCode: statusCode,
      component: "API",
    });
  }
}

// Exportar instancia singleton
export const errorLogService = new ErrorLogService();
